import { SAGA_ACTIONS } from "../../../_config";
import { useApiCall } from "../appApiCallHook";



export function useWorkRequestApi() {
  const callApi = useApiCall();

  const GetWorkRequestList = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.WORK_REQUEST.GET_WORK_REQUEST_LIST, data, onSuccess, onError);
  };

  const GetStatusList = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.WORK_REQUEST.GET_STATUS_LIST, data, onSuccess, onError);
  };

  const GetPriorityList = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.WORK_REQUEST.GET_PRIORITY_LIST, data, onSuccess, onError);
  };

  const GetCode = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.WORK_REQUEST.GET_CODE, data, onSuccess, onError);
  };

  const MoveStatus = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.WORK_REQUEST.MOVE_STATUS, data, onSuccess, onError);
  };


  const SaveWorkRequest = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.WORK_REQUEST.SAVE_WORK_REQUEST, data, onSuccess, onError);
  };

  const UploadImage = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.WORK_REQUEST.UPLOAD_IMAGE, data, onSuccess, onError);
  };


  const UploadAttachment = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.WORK_REQUEST.UPLOAD_ATTACHMENT, data, onSuccess, onError);
  };



  const GetWorkRequestByID = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.WORK_REQUEST.GET_WORK_REQUEST_BY_ID, data, onSuccess, onError);
  };


  const GetWorkRequestAttachments = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.WORK_REQUEST.GET_ATTACHMENT, data, onSuccess, onError);
  };


  const GetWorkRequestImages = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.WORK_REQUEST.GET_IMAGES, data, onSuccess, onError);
  };

  const DeleteWorkRequestFiles = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.WORK_REQUEST.DELETE_WORK_REQUEST_FILES, data, onSuccess, onError);
  };

  const SaveWorkRequestNotes = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.WORK_REQUEST.SAVE_WORK_REQUEST_NOTES, data, onSuccess, onError);
  };

  const DeleteWorkRequestNotes = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.WORK_REQUEST.DELETE_WORK_REQUEST_NOTES, data, onSuccess, onError);
  };

  const GetWorkRequestNotesList = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.WORK_REQUEST.GET_WORK_REQUEST_NOTES_LIST, data, onSuccess, onError);
  };

  const ExportToPDF = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.WORK_REQUEST.EXPORT_PDF, data, onSuccess, onError);
  };

  const ExportToXLS = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.WORK_REQUEST.EXPORT_XLS, data, onSuccess, onError);
  };

  const DeleteWorkRequest = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.WORK_REQUEST.DELETE_WORK_REQUEST, data, onSuccess, onError);
  };

  const GetListForKanbanView = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.WORK_REQUEST.GET_LIST_FOR_KANBAN_VIEW, data, onSuccess, onError);
  };

  const ProcessAudio = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.WORK_REQUEST.WORK_REQUEST_PROCESS_AUDIO, data, onSuccess, onError);
  };

  const ProcessFeedback = (data: any, onSuccess: Function, onError: Function) => {
    callApi(SAGA_ACTIONS.WORK_REQUEST.WORK_REQUEST_PROCESS_FEEDBACK, data, onSuccess, onError);
  };








  return {
    ExportToPDF,
    ExportToXLS,
    DeleteWorkRequest,
    GetWorkRequestList,
    GetStatusList,
    GetPriorityList,
    GetCode,
    MoveStatus,
    SaveWorkRequest,
    UploadImage,
    UploadAttachment,
    GetWorkRequestByID,
    GetWorkRequestAttachments,
    GetWorkRequestImages,
    DeleteWorkRequestFiles,
    SaveWorkRequestNotes,
    DeleteWorkRequestNotes,
    GetWorkRequestNotesList,
    GetListForKanbanView,
    ProcessAudio,
    ProcessFeedback
  };
}
